
<div class="pipeline-number-stat" :type="type">
	<div class="value">
		{{ value }}
	</div>
	<div class="separator">/</div>
	<div class="label">
		{{ label }}
	</div>
</div>
